export default __webpack_public_path__ + "media/images/folder-icon-for-email@2x-6eef54e2.png";